import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import AddIcons from '@/icons/AddIcons'
import { IPermissionProps } from '@/types/shared'
import { paths } from '@/utils/path'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Tabs } from 'vnetwork-ui'
import { useTabs as useMarketingTabs } from './tab'
import ExportContactButton from './ExportContactButton'
import ImportContactButton from './ImportContactButton'
import LeadsOverview from './Statistic/LeadsOverview'
import SalesOncallSchedule from './SalesOncallSchedule'
import LeadFilters from './LeadFilters'
import { LeadFiltersProvider } from './LeadFiltersContext'
import NewLeadNotification from './NewLeadNotification'
import { useTourHandler } from '@/contexts/tour-handler'
import { useContactSourceListTour } from './use-contact-source-list-tour'
import { useContactSourceListQuickHelp } from './use-contact-source-list-quick-help'

const ListContent: React.FC = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const tabs = useMarketingTabs()

    // Tour and Quick Help
    const { startTour } = useContactSourceListTour()
    const { registerHandler, unregisterHandler } = useTourHandler()
    useContactSourceListQuickHelp()

    // Register tour handler
    useEffect(() => {
        registerHandler(startTour)
        return () => unregisterHandler()
    }, [registerHandler, unregisterHandler, startTour])

    const { TabComponent, TabProps } = useTabs({
        tabs,
    })

    return (
        <div>
            <SubHeaders
                actions={[
                    {
                        icon: <AddIcons />,
                        label: t('add-customer'),
                        variant: 'contained',
                        onClick: () => navigate(paths.customerNewlMkt),
                        'data-tour': 'add-contact-btn',
                    },
                ]}
                components={[<ImportContactButton />, <ExportContactButton />]}
                breadcrumbs={[
                    {
                        path: paths.customerMkt,
                        title: t('customer-mkt'),
                    },
                ]}
            />

            {/* Top section: SalesOncall (6) + LeadsOverview (6) */}
            <div className="grid grid-cols-12 gap-2 mb-2 mt-2">
                <SalesOncallSchedule />
                <div className="col-span-12 lg:col-span-6">
                    <LeadsOverview />
                </div>
            </div>

            {/* Filters - collapsible */}
            <LeadFilters />
            <div data-tour="lead-tabs">
                <Tabs
                    {...TabProps}
                    tabContainerClassName="mb-2 !pt-2 rounded-sm"
                />
            </div>
            {TabComponent}
        </div>
    )
}

const List: React.FC<IPermissionProps> = () => {
    return (
        <LeadFiltersProvider>
            <NewLeadNotification />
            <ListContent />
        </LeadFiltersProvider>
    )
}

export default List
